export default __webpack_public_path__ + "static/media/remodel2.0680fd8a.png";